import { render } from "./RacerSelectBlock.vue?vue&type=template&id=6a07ded4&scoped=true"
import script from "./RacerSelectBlock.vue?vue&type=script&lang=js"
export * from "./RacerSelectBlock.vue?vue&type=script&lang=js"

import "./RacerSelectBlock.vue?vue&type=style&index=0&id=6a07ded4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a07ded4"]])

export default __exports__